module.exports = __webpack_public_path__ + "img/zip.7b295aa0.png";